import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { createContext } from 'react';

export type TrackingServiceContextState = {
  trackingService: TrackingServiceV2;
};

export const TrackingServiceContext = createContext<Partial<TrackingServiceContextState>>({});
